import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: coach.Rating.
export default class Rating extends Fragment {
  declare [Type]: 'coach/rating';

  // personId provides the unique identifier of the Person who has rated this suggestion.
  @attr('string', { defaultValue: '' })
  declare personId: string;

  // rating specifies the numerical rating out of five that a user has assigned the suggestion.
  @attr('number', { defaultValue: 0 })
  declare rating: number;
}
